import { Property } from "../../../../global/types";
import api from "../../../../services/api";
import Skeleton from "../../../../pages/NewHome/components/NewcomersSection/Skeleton";
import {
  DescriptionTitle,
  TitleSimilarProperties,
  Wrapper,
  PropertiesGrid,
} from "./styles";
import React, { useEffect, useState } from "react";
import PropertyCard from "../../../../components/PropertyCard";
import {
  SimilarPropertiesSource,
  extractPropertiesFromApiResponse,
  resolveSimilarPropertiesRequest,
} from "./fetchSimilarProperties";

interface IProps {
  similarRents?: Property;
  source?: SimilarPropertiesSource;
}

function SimilarProperties({
  similarRents: property,
  source = "related",
}: IProps) {
  const [properties, setProperties] = useState<Property[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isCancelled = false;

    async function loadSimilarProperties() {
      setLoading(true);

      try {
        const { endpoint, params } = resolveSimilarPropertiesRequest(
          source,
          property
        );
        const response = await api.get(endpoint, params ? { params } : undefined);
        if (isCancelled) {
          return;
        }
        setProperties(extractPropertiesFromApiResponse(response.data));
      } catch {
        if (!isCancelled) {
          setProperties([]);
        }
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    }

    loadSimilarProperties();

    return () => {
      isCancelled = true;
    };
  }, [property, source]);

  if (!loading && properties.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      <TitleSimilarProperties>
        <DescriptionTitle>Imóveis semelhantes</DescriptionTitle>
      </TitleSimilarProperties>

      {!loading ? (
        <PropertiesGrid>
          {properties.map((listedProperty) => (
            <PropertyCard
              key={listedProperty.id}
              property={listedProperty}
              isInitiallyFavorite={false}
            />
          ))}
        </PropertiesGrid>
      ) : (
        <Skeleton />
      )}
    </Wrapper>
  );
}

export default SimilarProperties;
